import { toast } from "sonner";

// Activation links to share manually when the email could not be sent (admin-only).
export const ClaimLinks = ({ links, testid = "claim-links-fallback" }) => {
  if (!links?.length) return null;
  return (
    <div className="mt-3 rounded-xl border-2 border-amber-300 bg-amber-50 p-3 text-xs" data-testid={testid}>
      <p className="font-semibold text-amber-900 mb-2">El email no salió. Copiá cada enlace y pasalo a mano (es personal y vence en 7 días):</p>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.email} className="flex flex-wrap items-center gap-2">
            <span className="font-medium">{l.email}</span>
            <code className="flex-1 min-w-0 truncate bg-white px-2 py-1 rounded">{l.link}</code>
            <button className="btn-outline text-xs" data-testid={`claim-link-copy-${l.email}`}
              onClick={() => navigator.clipboard.writeText(l.link).then(() => toast.success("Enlace copiado"))}>Copiar</button>
          </li>
        ))}
      </ul>
    </div>
  );
};
